require("users/userService").default;
require("user/userController");
require("user/userVerifyController");
require("user/userWallController");
require("user/userFriendsController");



// WEBPACK FOOTER //
// ./js/user/userLoader.js